import { DiamondCataloguePageLayout } from '@/features/journal/diamond-catalogue-page';

export { getDiamondCatalogueServerSideProps as getServerSideProps } from '@/features/journal/diamond-page-server';
export default DiamondCataloguePageLayout;
